import type { SearchResultResponse } from '@tabita/contracts';
import { apiRequest } from './api-client';

export const searchApi = {
  query(q: string, signal?: AbortSignal) {
    return apiRequest<readonly SearchResultResponse[]>('/search', { query: { q }, signal });
  },
};
